module.exports = __webpack_public_path__ + "img/ep7-2.451abbb6.png";